// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/img/icons/marevo-icon-close.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../public/img/icons/copy.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.share-ar__container {
  position: absolute;
  width: 30%;
  height: 20%;
  z-index: 11;
  max-width: 372px;
  background-color: #ffffff;
  right: calc(39vw + 72px);
  top: 50%;
  transform: translateY(-50%);
  padding: 30px;
}
.share-ar__container-share {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.share-ar__container-share__title {
  font-size: 18px;
  margin-bottom: 30px;
  border-bottom: 1px solid rgba(98, 154, 51, 0.3);
  width: 100%;
  text-align: center;
  padding: 10px;
  font-family: "Inter", serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  text-transform: uppercase;
  color: #629A33;
}
.share-ar__container-share__close {
  cursor: pointer;
  display: flex;
  width: 18px;
  height: 18px;
  position: absolute;
  top: 19px;
  right: 16px;
}
.share-ar__container-share__close::after {
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-repeat: no-repeat;
  width: 18px;
  height: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.share-ar__container-share__bottom {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-between;
}
.share-ar__container-share__bottom__link {
  padding: 11px 13px;
  width: 100%;
  height: 100%;
  border: 1px solid #629A33;
  font-family: "Inter", serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  margin-right: 12px;
}
.share-ar__container-share__bottom__button {
  cursor: pointer;
  height: 100%;
  width: 60px;
  border: none;
  outline: 0;
  background-color: #629A33;
  transition: all 0.3s;
}
.share-ar__container-share__bottom__button::after {
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: center;
  background-repeat: no-repeat;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.share-ar__container-share__bottom__button:hover {
  background-color: rgba(98, 154, 51, 0.5);
}

.ar {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.ar .share-ar__container-share__title {
  border-bottom: 0 !important;
  margin-bottom: 0 !important;
}
.ar__container {
  position: absolute;
  width: 30%;
  z-index: 11;
  background-color: #ffffff;
  right: calc(39vw + 72px);
  top: 50%;
  transform: translateY(-50%);
  padding: 30px;
  max-width: 305px;
}
.ar__title {
  font-size: 14px !important;
  font-family: "Inter", serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  margin-bottom: 40px;
  border-bottom: 1px solid rgba(98, 154, 51, 0.3);
  width: 100%;
  text-align: center;
  padding: 10px;
}
.ar__bottom {
  width: 170px;
  height: 170px;
  border: 1px solid rgba(98, 154, 51, 0.3);
}
.ar__bottom__qr {
  display: flex;
  width: 100%;
  height: 100%;
}
.ar__close {
  cursor: pointer;
  display: flex;
  width: 18px;
  height: 18px;
  position: absolute;
  top: 19px;
  right: 16px;
}
.ar__close::after {
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-repeat: no-repeat;
  width: 18px;
  height: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/components/shareAr/shareAr.scss","webpack://./src/styles/_variables.scss","webpack://./src/styles/_mixins.scss"],"names":[],"mappings":"AAGA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EAGA,yBCHY;EDKZ,wBAAA;EACA,QAAA;EACA,2BAAA;EACA,aAAA;AALF;AAOE;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AALJ;AAOI;EACE,eAAA;EAEA,mBAAA;EACA,+CAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EEtBH,2BAAA;EFyBG,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cCvCS;ADgCf;AAUI;EACE,eAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AARN;AAUM;EACE,WAAA;EACD,yDAAA;EACC,2BAAA;EACA,4BAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AARR;AAYI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;AAVN;AAYM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EEvCN,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EFsCM,kBAAA;AAPR;AAUM;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,yBCrFO;EDuFP,oBAAA;AATR;AAWQ;EACE,WAAA;EACA,yDAAA;EACA,2BAAA;EACA,4BAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AATV;AAYQ;EACE,wCAAA;AAVV;;AAiBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAdF;AAgBE;EACE,2BAAA;EACA,2BAAA;AAdJ;AAkBE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EAEA,yBCxHU;ED0HV,wBAAA;EACA,QAAA;EACA,2BAAA;EACA,aAAA;EACA,gBAAA;AAlBJ;AAqBE;EACE,0BAAA;EEpGF,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EFmGE,mBAAA;EACA,+CAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;AAhBJ;AAmBE;EACE,YAAA;EACA,aAAA;EACA,wCAAA;AAjBJ;AAmBI;EACE,aAAA;EACA,WAAA;EACA,YAAA;AAjBN;AAqBE;EACE,eAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AAnBJ;AAqBI;EACE,WAAA;EACN,yDAAA;EACM,2BAAA;EACA,4BAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAnBN","sourcesContent":["@use \"../../styles/mixins\" as mixins;\n@use \"../../styles/variables\" as vars;\n\n.share-ar__container {\n  position: absolute;\n  width: 30%;\n  height: 20%;\n  z-index: 11;\n  max-width: 372px;\n  // border: 1px solid rgba($color: vars.$second-color, $alpha: 0.5);\n\n  background-color: vars.$white-color;\n\n  right: calc(vars.$width-interface + 72px);\n  top: 50%;\n  transform: translateY(-50%);\n  padding: 30px;\n\n  &-share {\n    height: 100%;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n\n    &__title {\n      font-size: 18px;\n      // @include mixins.h3();\n      margin-bottom: 30px;\n      border-bottom: 1px solid rgba($color: vars.$second-color, $alpha: 0.3);\n      width: 100%;\n      text-align: center;\n      padding: 10px;\n\n      @include mixins.font-family-second();\n      font-weight: 400;\n      font-size: 18px;\n      line-height: 100%;\n      letter-spacing: 0%;\n      text-align: center;\n      text-transform: uppercase;\n      color: vars.$second-color;\n    }\n\n    &__close {\n      cursor: pointer;\n      display: flex;\n      width: 18px;\n      height: 18px;\n      position: absolute;\n      top: 19px;\n      right: 16px;\n\n      &::after {\n        content: \"\";\n       background-image: url(../../../public/img/icons/marevo-icon-close.svg);\n        background-position: center;\n        background-repeat: no-repeat;\n        width: 18px;\n        height: 18px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n      }\n    }\n\n    &__bottom {\n      width: 100%;\n      height: 50px;\n      display: flex;\n      justify-content: space-between;\n\n      &__link {\n        padding: 11px 13px;\n        width: 100%;\n        height: 100%;\n        border: 1px solid vars.$second-color;\n        @include mixins.h3();\n        margin-right: 12px;\n      }\n\n      &__button {\n        cursor: pointer;\n        height: 100%;\n        width: 60px;\n        border: none;\n        outline: 0;\n        background-color: vars.$second-color;\n\n        transition: all 0.3s;\n\n        &::after {\n          content: \"\";\n          background-image: url(../../../public/img/icons/copy.svg);\n          background-position: center;\n          background-repeat: no-repeat;\n          height: 24px;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n        }\n\n        &:hover {\n          background-color: rgba($color: vars.$second-color, $alpha: 0.5);\n        }\n      }\n    }\n  }\n}\n\n.ar {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  .share-ar__container-share__title {\n    border-bottom: 0 !important;\n    margin-bottom: 0 !important;\n    // padding-bott: 0 !important;\n  }\n\n  &__container {\n    position: absolute;\n    width: 30%;\n    z-index: 11;\n\n    background-color: vars.$white-color;\n\n    right: calc(vars.$width-interface + 72px);\n    top: 50%;\n    transform: translateY(-50%);\n    padding: 30px;\n    max-width: 305px;\n  }\n\n  &__title {\n    font-size: 14px !important;\n    @include mixins.h3();\n    margin-bottom: 40px;\n    border-bottom: 1px solid rgba($color: vars.$second-color, $alpha: 0.3);\n    width: 100%;\n    text-align: center;\n    padding: 10px;\n  }\n\n  &__bottom {\n    width: 170px;\n    height: 170px;\n    border: 1px solid rgba($color: vars.$second-color, $alpha: 0.3);\n\n    &__qr {\n      display: flex;\n      width: 100%;\n      height: 100%;\n    }\n  }\n\n  &__close {\n    cursor: pointer;\n    display: flex;\n    width: 18px;\n    height: 18px;\n    position: absolute;\n    top: 19px;\n    right: 16px;\n\n    &::after {\n      content: \"\";\nbackground-image: url(../../../public/img/icons/marevo-icon-close.svg);\n      background-position: center;\n      background-repeat: no-repeat;\n      width: 18px;\n      height: 18px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n  }\n}\n","$primary-color: #629A33;\n$secondary-color: #6c757d;\n$font-size-base: 16px;\n$second-color: #629A33;\n$second-color-1: #06aeef;\n$shadow-color: #47659314;\n$black-color:  #1A1A1A;\n$black-color-second: #3A3A3C;\n$white-color: #ffffff;\n$red-color: #ff214a;\n\n$margin-top-title-option: 10px;\n$padding-vertical-group-inputs: 20px;\n$width-interface: 39vw;\n","@use \"variables\" as vars;\n\n@mixin text-center {\n  text-align: center;\n}\n\n@mixin font-family {\n  font-family: \"Inter\", serif;\n}\n\n@mixin font-family-second {\n   font-family: \"Inter\", serif;\n}\n\n@mixin box-border($blur, $color) {\n  border: 0.5px solid $color;\n}\n\n@mixin box-border-solid($blur, $color) {\n  border: 1px solid $color;\n}\n\n@mixin box-shadow($color) {\n  box-shadow: 0px 0px 20px 0px rgba($color, 0.1);\n}\n\n@mixin radius() {\n  border-radius: 10px;\n}\n\n@mixin h2() {\n  font-family: \"Inter\", serif;\n  font-weight: 300;\n  font-size: 17px;\n  line-height: 100%;\n}\n\n@mixin h3() {\n  font-family: \"Inter\", serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21px;\n}\n\n@mixin h4() {\n  font-family: \"Inter\", serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21px;\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n}\n\n@mixin h5() {\n  font-family: \"Inter\", serif;\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 12px;\n  text-align: center;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n}\n\n@mixin bold {\n  font-family: \"Inter\", serif;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
